(() => {
  const initialise = () => {
    document.querySelectorAll('[data-dija-faq]').forEach((faq) => {
      if (faq.dataset.faqReady === 'true') return;
      faq.dataset.faqReady = 'true';

      const input = faq.querySelector('[data-faq-search]');
      const groups = [...faq.querySelectorAll('[data-faq-group]')];
      const empty = faq.querySelector('[data-faq-empty]');
      if (!input) return;

      input.addEventListener('input', () => {
        const term = input.value.trim().toLocaleLowerCase();
        let totalVisible = 0;

        groups.forEach((group) => {
          let groupVisible = 0;
          group.querySelectorAll('[data-faq-item]').forEach((item) => {
            const match = !term || item.textContent.toLocaleLowerCase().includes(term);
            item.hidden = !match;
            if (match) {
              groupVisible += 1;
              totalVisible += 1;
            }
          });
          group.hidden = groupVisible === 0;
        });

        if (empty) empty.hidden = totalVisible !== 0;
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
